import classNames from 'classnames';

type ButtonVariant = 'PRIMARY' | 'SECONDARY';
type ButtonSize = 'REGULAR' | 'WIDE';

type CalendlyLinkButtonProps = {
  type: 'calendly';
  trackingCategory: string;
  trackingAction?: string;
  calendlyLink?: string;
};

type RegularLinkButtonProps = {
  type: 'href';
  href: string;
};

type RegularButtonProps = {
  type: 'button';
  onClick: () => void;
};

type SubmitButtonProps = {
  type: 'submit';
  value: unknown;
};

type QuestionIdButtonProps = {
  type: 'question-id';
  questionId: string;
};

const buttonVariantMapping: Record<ButtonVariant, string> = {
  PRIMARY: 'p-btn--primary',
  SECONDARY: 'p-btn--secondary bg-white',
};

const buttonSizeMapping: Record<ButtonSize, string> = {
  REGULAR: 'wmn3',
  WIDE: 'wmn4',
};

type ButtonBaseProps = {
  caption: string;
  variant?: ButtonVariant;
  size?: ButtonSize;
};

export type GetButtonProps = ButtonBaseProps &
  (
    | CalendlyLinkButtonProps
    | RegularLinkButtonProps
    | RegularButtonProps
    | SubmitButtonProps
    | QuestionIdButtonProps
  );

export const getButton = ({
  index,
  caption,
  variant = 'PRIMARY',
  size = 'REGULAR',
  onSubmitValue = (_data: unknown) => {},
  navigateToQuestionId,
  ...specificProps
}: GetButtonProps & {
  index: number;
  onSubmitValue?: (data?: unknown) => void;
  navigateToQuestionId?: (questionId: string) => void;
}) => {
  const className = classNames(
    buttonVariantMapping[variant],
    buttonSizeMapping[size],
    'w100'
  );
  const key = String(`btn-${index}-${caption}`);
  switch (specificProps.type) {
    case 'calendly':
      return (
        <button
          className={className}
          onClick={() => console.log('Some click happened!')}
          type="button"
          key={key}
          data-cy="button-calendly"
        >
          {caption}
        </button>
      );
    case 'href': {
      const isHrefRelative = specificProps.href.startsWith('/');
      return (
        <a
          href={specificProps.href}
          className={className}
          key={key}
          target={isHrefRelative ? '_self' : '_blank'}
          rel="noreferrer"
          data-cy="button-href"
        >
          {caption}
        </a>
      );
    }
    case 'submit':
      return (
        <button
          onClick={() => {
            onSubmitValue(specificProps.value ?? true);
          }}
          className={className}
          key={key}
          type="button"
          data-cy="button-submit"
        >
          {caption}
        </button>
      );
    case 'question-id':
      return (
        <button
          onClick={() => navigateToQuestionId?.(specificProps.questionId)}
          className={className}
          key={key}
          type="button"
          data-cy="button-question-id"
        >
          {caption}
        </button>
      );
    default:
      return (
        <button
          onClick={specificProps.onClick}
          className={className}
          key={key}
          type="button"
          data-cy="button-continue"
        >
          {caption}
        </button>
      );
  }
};
